import { IErrorDetail, IValidationResult, IValidationField } from './interfaces/validation.interface';

export class ContentValidatorHelper {
  /**
   * Check if a certain has errors or not
   * @param validation Validation Result
   */
  static hasError(validation: IValidationResult): boolean {
    return validation.errors.length > 0;
  }

  static createValidation(errors?: IValidationField[], warnings?: IValidationField[]): IValidationResult {
    return { errors: errors || [], warnings: warnings || [] };
  }

  static createErrorDetails(details?: IErrorDetail[]): IErrorDetail[] {
    return [...(details || [])];
  }

  /**
   * Merge many validations into one validation result
   */
  static mergeValidations(validations: IValidationResult[]): IValidationResult {
    const errors = validations.map(validation => validation.errors);
    const warnings = validations.map(validation => validation.warnings);

    return {
      errors: errors.flat(),
      warnings: warnings.flat(),
    };
  }

  /**
   * Verify if there is any validation result with none errors
   * @param validations Array of validation results
   * ---
   * @example
   * ```typescript
   * hasValidationWithoutErrors([
   *  { errors: [{message: 'a'}], warnings: []},
   *  { errors: [], warnings: []}
   * ]) -> true
   * ```
   * Returns `true` since the second element doesn't has any error
   *
   * ---
   *
   * ```typescript
   * hasValidationWithoutErrors([
   *  { errors: [{message: 'a'}], warnings: []},
   *  { errors: [{message: 'b'}], warnings: []}
   * ]) -> false
   * ```
   * Returns `false` since the all given validations has at least one error
   */
  static hasValidationWithoutErrors(validations: Array<IErrorDetail[]>): boolean {
    return validations.some(validation => validation.length === 0);
  }
}
